module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.backgroundClass],
    attrs: {
      "id": "carouselContainer"
    }
  }, [_vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInDown",
      "leave-active-class": "animated fadeOutDownBig"
    }
  }, [(_vm.itemState === 'zero') ? _c('div', {
    key: "zero",
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('headlineZeroTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('headlineZeroDescp')))]), _vm._v(" "), _c('a', {
    staticClass: "explore-more-btn",
    attrs: {
      "href": "./docode.html"
    }
  }, [_vm._v("EXPLORE MORE")])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('img', {
    attrs: {
      "width": "60%",
      "src": "assets/images/carousel/item0.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.itemState === 'one') ? _c('div', {
    key: "one",
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('headlineOneTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('headlineOneDescp')))])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "assets/images/carousel/item1.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.itemState === 'two') ? _c('div', {
    key: "two",
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('headlineTwoTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('headlineTwoDescp')))])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "assets/images/carousel/item2.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.itemState === 'three') ? _c('div', {
    key: "three",
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('headlineThreeTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('headlineThreeDescp')))])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "assets/images/carousel/item3.png",
      "alt": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.headlines), function(hl, hidx) {
    return _c('li', {
      class: {
        'active': hl.active
      },
      on: {
        "click": function($event) {
          _vm.changeHeadline(hidx, hl)
        }
      }
    }, [_c('i', {
      staticClass: "en",
      class: [hl.iconClass],
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/carousel/bg1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "assets/images/carousel/bg2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "assets/images/carousel/bg3.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bbdf29c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/CarouselNew.vue
// module id = 408
// module chunks = 3